import { useState } from "react";
import { Link, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Cleaning from "./pages/Cleaning";
import ComHab from "./pages/Comhab";
import Respite from "./pages/Respite";
import OPWDD from "./pages/OPWDD";
import Transportation from "./pages/Transportation";
import Activities from "./pages/Activities";
import AddActivity from "./pages/AddActivity";
import Yardwork from "./pages/Yardwork";
import Laundry from "./pages/Laundry";
import Broker from "./pages/Broker";
import JoinDSPNetwork from "./pages/Join_DSP_Network";

import FAQ from "./pages/faq";
import Contact from "./pages/contact";
import FIResources from "./pages/FIResources";
import FamiliesSeekingSupport from "./pages/FamiliesSeekingSupport";
import EditDSPProfile from "./pages/EditDSPProfile";

import About from "./pages/Footer_pages/About";
import Advertise from "./pages/Footer_pages/Advertise";
import Terms from "./pages/Footer_pages/Terms";
import Privacy from "./pages/Footer_pages/Privacy";
import Cookies from "./pages/Footer_pages/Cookies";
import DoNotSell from "./pages/Footer_pages/DoNotSell";
import Accessibility from "./pages/Footer_pages/Accessibility";

import logo from "./assets/favicon_no_B.PNG";
import Footer from "./pages/Footer";
import TermsPopup from "./components/TermsPopup";
import Notary from "./pages/Footer_pages/Notary";
import Jobs from "./pages/Footer_pages/Jobs";

const navBubbleStyle = {
  textDecoration: "none",
  color: "white",
  fontWeight: "600",
  fontSize: "16px",
  backgroundColor: "rgba(255, 255, 255, 0.18)",
  padding: "8px 16px",
  borderRadius: "10px",
  display: "inline-block",
  whiteSpace: "nowrap"
};

export default function App() {
  const [showDonate, setShowDonate] = useState(false);

  const donateBubbleStyle = {
    position: "fixed",
    top: "78px",
    right: "18px",
    zIndex: 9999
  };

  const donateButtonStyle = {
    backgroundColor: "#2f6f89",
    color: "white",
    border: "none",
    borderRadius: "999px",
    padding: "10px 16px",
    fontWeight: "600",
    fontSize: "14px",
    cursor: "pointer",
    boxShadow: "0 8px 20px rgba(0,0,0,0.15)"
  };

  const donatePopupStyle = {
    marginTop: "10px",
    width: "270px",
    backgroundColor: "white",
    borderRadius: "14px",
    padding: "16px",
    boxShadow: "0 12px 28px rgba(0,0,0,0.18)",
    color: "#333",
    textAlign: "left"
  };

  const donateLinkStyle = {
    display: "inline-block",
    marginTop: "12px",
    backgroundColor: "#2f6f89",
    color: "white",
    textDecoration: "none",
    padding: "10px 16px",
    borderRadius: "10px",
    fontWeight: "600"
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh"
      }}
    >
      <TermsPopup />

      <div
        className="title-bar"
        style={{
          position: "relative",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          height: "62px",
          paddingTop: "13px",
          paddingLeft: "12px"
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "12px"
          }}
        >
          <Link to="/" style={navBubbleStyle}>
            Home
          </Link>

          <Link to="/faq" style={navBubbleStyle}>
            Help
          </Link>
        </div>

        <Link to="/">
          <img
            src={logo}
            alt="Hopeful Horizons logo"
            style={{
              position: "absolute",
              right: "18px",
              top: "8px",
              height: "50px"
            }}
          />
        </Link>
      </div>

      <div style={donateBubbleStyle}>
        <button
          style={donateButtonStyle}
          onClick={() => setShowDonate(!showDonate)}
        >
          💙 Support
        </button>

        {showDonate && (
          <div style={donatePopupStyle}>
            <div
              style={{
                fontWeight: "700",
                color: "#2f6f89",
                marginBottom: "8px"
              }}
            >
              Keep this resource free
            </div>

            <div
              style={{
                fontSize: "0.95rem",
                lineHeight: "1.5"
              }}
            >
              This website is free for families and Self-Direction participants.
              Donations help us maintain and improve this resource for the
              community.
            </div>

            <a
              href="https://donate.stripe.com/14A7sK7as10ygDzb7k8so00"
              target="_blank"
              rel="noopener noreferrer"
              style={donateLinkStyle}
            >
              Donate
            </a>
          </div>
        )}
      </div>

      <div className="app-shell" style={{ flex: 1 }}>
        <main className="container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cleaning" element={<Cleaning />} />
            <Route path="/comhab" element={<ComHab />} />
            <Route path="/respite" element={<Respite />} />
            <Route path="/opwdd" element={<OPWDD />} />
            <Route path="/transportation" element={<Transportation />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/add-activity" element={<AddActivity />} />
            <Route path="/yardwork" element={<Yardwork />} />
            <Route path="/laundry" element={<Laundry />} />
            <Route path="/broker" element={<Broker />} />
            <Route path="/join-dsp-network" element={<JoinDSPNetwork />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/fi" element={<FIResources />} />
<Route path="/families-seeking-support" element={<FamiliesSeekingSupport />} />
            <Route path="/edit-dsp-profile" element={<EditDSPProfile />} />
            <Route path="/about" element={<About />} />
            <Route path="/advertise" element={<Advertise />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/donotsell" element={<DoNotSell />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/notary" element={<Notary />} />
            <Route path="/jobs" element={<Jobs />} />
          </Routes>
        </main>
      </div>

      <Footer />
    </div>
  );
}